import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AvatarBadge from "src/Components/AvatarBadge";
import styles from "src/Assets/css/home/post.module.css";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import inviteToBeImapctFullMemberImage from "src/Assets/images/impactful_nominate_img_new.png";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import closeIcon from "src/Assets/images/Add.png";
import moderatorBlogStyles from "src/Assets/css/Moderator/ModeratorBlog.module.css";
import API from "../../../network";
import {
  capitalizeFirstLetter,
  ignoreSpacesAndUrlsFromMsg,
} from "src/Utils/commonUtils";
import NominateUser from "src/Modules/Moderator/ReusableModeratorComponents/NominateUser";

export function ProfileHoverCard({
  result,
  showData = "",
  parentMsgId,
  filterType = "",
  flow = "",
  isActionDisabled = false,
  onActionSuccess,
}) {
  const history = useHistory();
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  const communityFollowNames = userDetails?.userData?.communityFollowNames || [];
  const targetTenantId =
    result?.tenantID ||
    result?.Tenant_ID ||
    result?.mainuserdata?.tenantID;
  const hasFollowedTarget = targetTenantId
    ? communityFollowNames.some(
        (c) =>
          String(c.id) === String(targetTenantId) ||
          String(c.tenantID) === String(targetTenantId) ||
          String(c.tenantId) === String(targetTenantId)
      )
    : false;
  const isPrivate =
    isActionDisabled ||
    result?.tenanttype?.toLowerCase() === "private" ||
    result?.mainuserdata?.tenanttype?.toLowerCase() === "private";
  const isNominateDisabled =
    flow === "beforeSignIn" || (isPrivate && !hasFollowedTarget);

  // Controls Impactful Member popup visibility
  const [showImpactfulMemberPopup, setShowImpactfulMemberPopup] =
    useState(false);

  // Hover and positioning state for portaled ProfileHoverCard
  const [isHovered, setIsHovered] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0, isFlipped: false });
  const anchorRef = useRef(null);
  const hoverCardRef = useRef(null);
  const closeTimeoutRef = useRef(null);
  const isMouseOverCardRef = useRef(false);
  const isMouseOverTriggerRef = useRef(false);
  const cardIdRef = useRef(Math.random().toString(36).slice(2));

  const updatePosition = () => {
    const anchor = anchorRef.current;
    if (!anchor) return;
    const triggerEl = anchor.parentElement;
    if (!triggerEl) return;
    const rect = triggerEl.getBoundingClientRect();

    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      setIsHovered(false);
      return;
    }

    const cardWidth = 400;
    // Use actual measured height of the card if rendered, or fallback to 140px
    const cardHeight = hoverCardRef.current?.offsetHeight || 140;
    const margin = 8;

    let left = rect.left;
    if (left + cardWidth > window.innerWidth - 16) {
      left = Math.max(16, window.innerWidth - cardWidth - 16);
    }
    if (left < 16) left = 16;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    let isFlipped = false;
    let top = 0;

    // As long as there is enough space below to fit the card, ALWAYS open downside.
    // Only flip upside when it physically cannot fit downside AND there is more room upside.
    const fitsDownside = spaceBelow >= (cardHeight + margin);
    if (!fitsDownside && spaceAbove > spaceBelow) {
      isFlipped = true;
      top = rect.top - margin;
    } else {
      isFlipped = false;
      top = rect.bottom + margin;
    }

    setPosition({ top, left, isFlipped });
  };

  const openHoverCard = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    updatePosition();
    setIsHovered(true);
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("skopic:closeHoverCards", {
          detail: { cardId: cardIdRef.current },
        }),
      );
    }
  };

  const closeHoverCard = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    closeTimeoutRef.current = setTimeout(() => {
      if (!isMouseOverCardRef.current && !isMouseOverTriggerRef.current) {
        setIsHovered(false);
      }
    }, 150);
  };

  useEffect(() => {
    const anchor = anchorRef.current;
    if (!anchor) return;
    const triggerEl = anchor.parentElement;
    if (!triggerEl) return;

    const onTriggerEnter = () => {
      isMouseOverTriggerRef.current = true;
      openHoverCard();
    };
    const onTriggerLeave = () => {
      isMouseOverTriggerRef.current = false;
      closeHoverCard();
    };

    triggerEl.addEventListener("mouseenter", onTriggerEnter);
    triggerEl.addEventListener("mouseleave", onTriggerLeave);

    let nameEl = null;
    try {
      if (feedstyles?.profilename) {
        nameEl = triggerEl.parentElement?.getElementsByClassName(feedstyles.profilename)[0];
        if (!nameEl) {
          const parentRow = triggerEl.closest('div[class*="postedcomment"]');
          nameEl = parentRow?.getElementsByClassName(feedstyles.profilename)[0];
        }
      }
    } catch (err) {
      console.warn("Error finding name element for hover card:", err);
    }

    if (nameEl) {
      nameEl.addEventListener("mouseenter", onTriggerEnter);
      nameEl.addEventListener("mouseleave", onTriggerLeave);
    }

    return () => {
      triggerEl.removeEventListener("mouseenter", onTriggerEnter);
      triggerEl.removeEventListener("mouseleave", onTriggerLeave);
      if (nameEl) {
        nameEl.removeEventListener("mouseenter", onTriggerEnter);
        nameEl.removeEventListener("mouseleave", onTriggerLeave);
      }
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleCloseOthers = (e) => {
      if (e?.detail?.cardId !== cardIdRef.current) {
        if (closeTimeoutRef.current) {
          clearTimeout(closeTimeoutRef.current);
          closeTimeoutRef.current = null;
        }
        isMouseOverCardRef.current = false;
        isMouseOverTriggerRef.current = false;
        setIsHovered(false);
      }
    };
    window.addEventListener("skopic:closeHoverCards", handleCloseOthers);
    return () => {
      window.removeEventListener("skopic:closeHoverCards", handleCloseOthers);
    };
  }, []);

  useEffect(() => {
    if (!isHovered) return;

    const handleScrollOrResize = () => {
      updatePosition();
    };

    window.addEventListener("scroll", handleScrollOrResize, true);
    window.addEventListener("resize", handleScrollOrResize);

    return () => {
      window.removeEventListener("scroll", handleScrollOrResize, true);
      window.removeEventListener("resize", handleScrollOrResize);
    };
  }, [isHovered]);

  const onCardMouseEnter = () => {
    isMouseOverCardRef.current = true;
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  const onCardMouseLeave = () => {
    isMouseOverCardRef.current = false;
    closeHoverCard();
  };

  // Impactful member message
  const [impactfulMemberText, setImpactfulMemberText] = useState("");
  const [impactfulMemberCharCount, setImpactfulMemberCharCount] = useState(0);
  const [isPostingImpactfulMember, setIsPostingImpactfulMember] =
    useState(false);

  // Handle impactful member text changes
  const onImpactfulMemberTextChange = (e) => {
    const textValue = e.target.value;

    const { msgLength } = ignoreSpacesAndUrlsFromMsg(textValue);

    const formattedValue = capitalizeFirstLetter(textValue);

    setImpactfulMemberCharCount(msgLength);
    setImpactfulMemberText(formattedValue);
  };

  // Nominate user as an Impactful Member
  const postImpactfulMember = async () => {
    try {
      if (!impactfulMemberText.trim() || impactfulMemberCharCount > 280) {
        return;
      }

      setIsPostingImpactfulMember(true);

      const formData = new FormData();
      const tenantID =
        result?.tenantID || result?.Tenant_ID || result?.mainuserdata?.tenantID;

      formData.append("userid", result?.mainuserdata?.userid);
      formData.append("tenantid", tenantID);
      formData.append("description", impactfulMemberText.trim());
      formData.append("dispayname", result?.mainuserdata?.displayName);

      const response = await API.nominateUser(formData);

      const statusMessage =
        response?.data?.formstatus || response?.data?.status;

      if (!statusMessage) {
        return;
      }

      alert(statusMessage);

      // Clear form and close popup only on successful nomination
      if (
        statusMessage.toLowerCase().includes("submitted") ||
        statusMessage.toLowerCase().includes("nominated")
      ) {
        setShowImpactfulMemberPopup(false);
        setImpactfulMemberText("");
        setImpactfulMemberCharCount(0);
      }
    } catch (error) {
      console.error("Error nominating impactful member:", error);
    } finally {
      setIsPostingImpactfulMember(false);
    }
  };
  // Check whether the selected user is already nominated
  const onNominateUser = async (result) => {
    try {
      // User is already an Impactful Member
      if (
        result?.mainuserdata?.isImpactableMember === "yes" ||
        result?.isImpactableMember === "yes"
      ) {
        alert(
          `${result?.mainuserdata?.displayName} is already an Impactful Member.`,
        );
        return;
      }
      const tenantID =
        result?.tenantID || result?.Tenant_ID || result?.mainuserdata?.tenantID;
      const response = await API.checkNominationStatus(
        tenantID,
        result?.mainuserdata?.userid,
      );

      console.log("Nomination status response:", response?.data);

      // User is already nominated
      if (response?.data?.isAlreadyNominated === 1) {
        alert("You already nominated.");
        return;
      }

      // Open nomination popup
      setIsHovered(false);
      setShowImpactfulMemberPopup(true);
    } catch (error) {
      console.error("Error checking nomination status:", error);
    }
  };

  // console.log(`hover card data:`, result);

  return (
    <>
      <span ref={anchorRef} style={{ display: "none" }} />
      {isHovered &&
        typeof document !== "undefined" &&
        ReactDOM.createPortal(
          <div
            ref={hoverCardRef}
            className={feedstyles.profilehover}
            onMouseEnter={onCardMouseEnter}
            onMouseLeave={onCardMouseLeave}
            style={{
              display: "block",
              position: "fixed",
              top: `${position.top}px`,
              left: `${position.left}px`,
              transform: position.isFlipped ? "translateY(-100%)" : "none",
              zIndex: 9999,
            }}
          >
            <div className={feedstyles.profilehoverimageandcount}>
              <div>
                <AvatarBadge
                  src={`${profileImagePath}${result?.mainuserdata?.uimage}`}
                  className={styles.avatar}
                  alt={userDetails?.userData?.displayName}
                  isPrimaryModerator={
                    result?.mainuserdata?.isPM == 1 &&
                    result?.mainuserdata?.isModerator == 1
                  }
                  isModerator={
                    result?.mainuserdata?.isPM == 0 &&
                    result?.mainuserdata?.isModerator == 1
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  alignItems: "flex-start",
                  flex: 1,
                }}
              >
                <div style={{ marginLeft: "10px", flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {result?.mainuserdata?.userid === userDetails?.userData?.User_ID ? (
                      <p
                        className={feedstyles.profilehovername}
                        style={{ margin: 0, cursor: "pointer", fontSize: "15px", fontWeight: "700", color: "#1f2937" }}
                        onClick={() => history?.push("/editprofile")}
                      >
                        {result?.mainuserdata?.displayName}
                      </p>
                    ) : (
                      <p
                        className={feedstyles.profilehovername}
                        style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#1f2937" }}
                      >
                        {result?.mainuserdata?.displayName}
                      </p>
                    )}

                    {(result?.mainuserdata?.isImpactableMember === "yes" ||
                      result?.isImpactableMember === "yes") && (
                      <img
                        src={alreadyImpactfulMemberImg}
                        alt="Impactful Member"
                        title="Impactful Member"
                        style={{
                          width: "18px",
                          height: "18px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </div>
                  <p
                    className={feedstyles.profilecount}
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "#6b7280",
                      marginTop: "4px",
                      lineHeight: "1.4",
                    }}
                  >
                    ASK {result?.mainuserdata?.askcount} | SAY{" "}
                    {result?.mainuserdata?.saycount} | UPDATE{" "}
                    {result?.mainuserdata?.updatecount} | TAG{" "}
                    {result?.mainuserdata?.hashtagcount} | Answers{" "}
                    {result?.mainuserdata?.answercount} | Replies{" "}
                    {result?.mainuserdata?.replycount}
                  </p>
                </div>
                {result?.mainuserdata?.userid !== userDetails?.userData?.User_ID && (
                  <NominateUser
                    result={result}
                    disabled={isNominateDisabled}
                    onActionSuccess={onActionSuccess}
                    onModalOpen={() => {
                      isMouseOverCardRef.current = false;
                      isMouseOverTriggerRef.current = false;
                      if (closeTimeoutRef.current) {
                        clearTimeout(closeTimeoutRef.current);
                        closeTimeoutRef.current = null;
                      }
                    }}
                    onModalClose={() => {
                      isMouseOverCardRef.current = false;
                      isMouseOverTriggerRef.current = false;
                      if (closeTimeoutRef.current) {
                        clearTimeout(closeTimeoutRef.current);
                        closeTimeoutRef.current = null;
                      }
                      setIsHovered(false);
                    }}
                  >
                    <button
                      type="button"
                      style={{
                        padding: 0,
                        margin: 0,
                        border: "none",
                        background: "transparent",
                        cursor: isNominateDisabled ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        outline: "none",
                      }}
                    >
                      <img
                        src={inviteToBeImapctFullMemberImage}
                        alt="Invite"
                        title={isNominateDisabled ? "Follow community to nominate" : "Nominate as Impactful Member"}
                        style={{
                          width: "23px",
                          height: "23px",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </button>
                  </NominateUser>
                )}
              </div>
            </div>
            {result?.mainuserdata?.shortBio ? (
              <div
                style={{
                  marginTop: "12px",
                  paddingTop: "10px",
                  borderTop: "1px solid #e5e7eb",
                }}
              >
                <p
                  className={feedstyles.profilehovercontent}
                  style={{
                    fontSize: "13px",
                    fontWeight: "400",
                    color: "#374151",
                    margin: 0,
                    lineHeight: "1.5",
                    wordBreak: "break-word",
                  }}
                >
                  {result?.mainuserdata?.shortBio}
                </p>
              </div>
            ) : null}
          </div>,
          document.body,
        )}
      <Modal
        open={showImpactfulMemberPopup}
        onClose={() => setShowImpactfulMemberPopup(false)}
        sx={{
          zIndex: 10000,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            borderRadius: "20px",
            padding: "16px 16px 5px 16px",
            width: "90%",
            maxWidth: "600px",
            outline: "none",
            boxShadow: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
              padding: "0 30px",
            }}
          >
            <h4
              style={{
                margin: 0,
                lineHeight: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              Impactful Member
            </h4>

            <img
              src={closeIcon}
              alt="Close"
              onClick={() => setShowImpactfulMemberPopup(false)}
              style={{
                width: 18,
                height: 18,
                cursor: "pointer",
                display: "block",
              }}
            />
          </div>

          <div className={moderatorBlogStyles.blogPostContainer}>
            <div className={moderatorBlogStyles.textAreaContainer}>
              <textarea
                name="impactfulMember"
                id="impactfulMember"
                className={moderatorBlogStyles.impactfulMemberModalTextArea}
                placeholder={`Why would you like to nominate ${result?.mainuserdata?.displayName} as an Impactful Member?`}
                value={impactfulMemberText}
                onChange={onImpactfulMemberTextChange}
              />

              <div className={moderatorBlogStyles.charCountContainer}>
                <label
                  style={{
                    color: impactfulMemberCharCount > 280 ? "red" : "#666",
                  }}
                >
                  {impactfulMemberCharCount}
                </label>
                <label>/280</label>
              </div>
            </div>

            <div className={moderatorBlogStyles.buttonContainer}>
              <button
                className={moderatorBlogStyles.postButton}
                disabled={
                  !impactfulMemberText.trim() ||
                  impactfulMemberCharCount > 280 ||
                  isPostingImpactfulMember
                }
                onClick={postImpactfulMember}
              >
                {isPostingImpactfulMember ? "Sending..." : "Send"}
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
